const btnFilterManagementBackups = {
  Typography: 'Nenhum resultado encontrado'
};

export default btnFilterManagementBackups;
